import React, { useState } from 'react';
import { Typography, Box, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import backgroundImage1 from '../../images/homeimge.jpg'; // Update the path if necessary

function Secone() {
  const navigate = useNavigate();

  const page = {
    backgroundImage: backgroundImage1,
    subtitle: "Nature's Wonders Await You",
    title: "Unseen Knuckles Eco Boutique",
    
  };

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        backgroundImage: `url(${page.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
      }}
    >
      {/* Overlay for dimming the background */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)', // Slight dark overlay
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
        }}
      >
        {/* Main Title */}
        <Typography
          variant="h1"
          sx={{
            fontWeight: 300,
            fontSize: { xs: '3.5rem', md: '8rem' },
            lineHeight: 1.2,
            color: 'white',
            textTransform: 'capitalize',
            fontFamily: "'Playfair Display', serif", // Apply custom font
            mb: 2,
          }}
        >
          {page.title}
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            fontSize: { xs: '1rem', md: '2rem' },
            lineHeight: 1.6,
            color: 'rgba(255, 255, 255, 0.85)',
            
          }}
        >
          {page.subtitle}
        </Typography>

       
      </Container>
    </Box>
  );
}

export default Secone;
